import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b94b258"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteLabel',
  props: {
        companyName: {type: String, required: true, default: ''},
        companyLogo: {type: String, required: true, default: ''},
        isReduced: {type: Boolean, required: true, default: false},
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  const _component_VJoyCompanyAvatar = _resolveComponent("VJoyCompanyAvatar")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (__props.companyName != '')
    ? (_openBlock(), _createBlock(_component_VJoyWrapper, {
        key: 0,
        class: "white-label-container",
        "no-margin": "",
        direction: "row",
        justify: "flex-start",
        wrap: "nowrap",
        "column-gap": "2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VJoyCompanyAvatar, {
            size: "medium",
            "company-name": __props.companyName,
            "img-src": __props.companyLogo,
            "img-alt": __props.companyName
          }, null, 8, ["company-name", "img-src", "img-alt"]),
          (!__props.isReduced)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.companyName), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})